import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router-dom";

const SinglePost = () => {
  const { slug } = useParams();
  const [post, setPost] = useState(null);

  useEffect(() => {
    axios
      .get(`https://wpdbstudio.com/wp-json/wp/v2/posts?slug=${slug}`)
      .then((res) => {
        setPost(res.data[0]);
      });
  }, [slug]);

  if (!post) return <p>Loading...</p>;

  return (
    <div className="container mt-4">
      <h1 dangerouslySetInnerHTML={{ __html: post.title.rendered }} />
      <div
        dangerouslySetInnerHTML={{ __html: post.content.rendered }}
      />
    </div>
  );
};

export default SinglePost;
